export default "__VITE_ASSET__Bfzeq97k__"